import type { RouteObject } from "@/types/route"

import {
  IconDashboard,
  IconBook,
  IconUserShield,
  IconUsers,
  IconLock,
  IconAbc,
  IconRoute,
  IconLink,
  IconQuote,
  IconFolder,
  IconBookmark,
  IconNotebook,
  IconBell,
  IconBug,
  IconListDetails,
  IconSearch,
  IconPlaylistAdd,
  IconTrophy,
  IconCoins,
  IconSparkles,
  IconMail,
  IconLanguage,
  IconMicrophone,
  IconServer,
  IconFolderSearch,
  IconBook2,
  IconSettings,
  IconLibrary,
  IconVideo,
} from "@tabler/icons-react"
import { AdminPage } from "@/views/admin"
import { FeedbackPage } from "@/views/feedback"
import { SettingsPage } from "@/views/settings"
import { SearchLogPage } from "@/views/log/search"
import { SetSearchLogPage } from "@/views/log/set-search"
import { AddVocabularyLogPage } from "@/views/log/add-vocabulary"
import { AiLogPage } from "@/views/log/ai"
import { EmailLogPage } from "@/views/log/email"
import { AiWordPage } from "@/views/log/ai-word"
import { SpeechAssessmentLogPage } from "@/views/log/speech-assessment"
import { ReadingPracticeLogPage } from "@/views/log/reading-practice"
import { SystemLogPage } from "@/views/log/system-service"
import { RolePage } from "@/views/role"
import { HeadwordPage } from "@/views/dictionary/headword"
import HeadwordDetailPage from "@/views/dictionary/headword/detail"
import { PhrasalVerbPage } from "@/views/dictionary/phrasal-verb"
import { CollocationPage } from "@/views/dictionary/collocation"
import { IdiomPage } from "@/views/dictionary/idiom"
import { UserPage } from "@/views/user"
import { UserSetPage } from "@/views/notebook/user-set"
import { UserVocabularyPage } from "@/views/notebook/user-vocabulary"
import { SystemSetPage } from "@/views/notebook/system-set"
import { SystemSetEditPage } from "@/views/notebook/system-set/edit"
import { SystemVocabularyPage } from "@/views/notebook/system-vocabulary"
import { ReadingContentPage } from "@/views/notebook/reading-content"
import { DashboardPage } from "@/views/dashboard"
import { ArticlePage } from "@/views/article"
import { ArticleFormPage } from "@/views/article/form"
import { LevelPage } from "@/views/gamification/level"
import { PointTransactionPage } from "@/views/gamification/point-transaction"
import { VideoPage } from "@/views/video"
import { VideoDetailPage } from "@/views/video/detail"

const routes: RouteObject[] = [
  {
    name: "Dashboard",
    path: "/dashboard",
    Component: DashboardPage,
    icon: <IconDashboard size={18} />,
    isMenu: true,
  },

  // ================= ADMIN =================
  {
    name: "Quản lý tài khoản Admin",
    // path: "/admin",
    icon: <IconUserShield size={18} />,
    isMenu: true,
    children: [
      {
        name: "DS Admin",
        path: "/admin-account",
        Component: AdminPage,
        icon: <IconUsers size={18} />,
        isMenu: true,
      },
      {
        name: "Quản lý Role",
        path: "/role",
        Component: RolePage,
        icon: <IconLock size={18} />,
        isMenu: true,
      },
    ],
  },

  // ================= USER =================
  {
    name: "Quản lý tài khoản User",
    // path: "/user",
    icon: <IconUsers size={18} />,
    isMenu: true,
    children: [
      {
        name: "DS User",
        path: "/user-account",
        Component: UserPage,
        icon: <IconUsers size={18} />,
        isMenu: true,
      },
    ],
  },

  // ================= DICTIONARY =================
  {
    name: "Quản lý từ điển",
    // path: "/dict",
    icon: <IconBook size={18} />,
    isMenu: true,
    children: [
      {
        name: "Từ gốc",
        path: "/dict/headword",
        Component: HeadwordPage,
        icon: <IconAbc size={18} />,
        isMenu: true,
      },
      {
        name: "Chi tiết từ gốc",
        path: "/dict/headword/:id",
        Component: HeadwordDetailPage,
        isMenu: false,
      },
      {
        name: "Cụm động từ",
        path: "/dict/phrasal-verb",
        Component: PhrasalVerbPage,
        icon: <IconRoute size={18} />,
        isMenu: true,
      },
      {
        name: "Collocations",
        path: "/dict/collocation",
        Component: CollocationPage,
        icon: <IconLink size={18} />,
        isMenu: true,
      },
      {
        name: "Thành ngữ",
        path: "/dict/idiom",
        Component: IdiomPage,
        icon: <IconQuote size={18} />,
        isMenu: true,
      },
    ],
  },

  // ================= VOCABULARY BOOK =================
  {
    name: "Sổ từ vựng",
    icon: <IconNotebook size={18} />,
    isMenu: true,
    children: [
      {
        name: "Bộ từ của hệ thống",
        path: "/notebook/system-set",
        Component: SystemSetPage,
        icon: <IconFolder size={18} />,
        isMenu: true,
      },
      {
        name: "Sửa bộ từ",
        path: "/notebook/system-set/edit/:id",
        Component: SystemSetEditPage,
        isMenu: false,
      },
      {
        name: "Từ vựng của hệ thống",
        path: "/notebook/system-vocabulary",
        Component: SystemVocabularyPage,
        icon: <IconBookmark size={18} />,
        isMenu: true,
      },
      {
        name: "Bài đọc theo Bộ từ",
        path: "/notebook/reading-content",
        Component: ReadingContentPage,
        icon: <IconBook2 size={18} />,
        isMenu: true,
      },
      {
        name: "Bộ từ của người dùng",
        path: "/notebook/user-set",
        Component: UserSetPage,
        icon: <IconFolder size={18} />,
        isMenu: true,
      },
      {
        name: "Từ vựng của người dùng",
        path: "/notebook/user-vocabulary",
        Component: UserVocabularyPage,
        icon: <IconBookmark size={18} />,
        isMenu: true,
      },
    ],
  },
  // ================= THƯ VIỆN =================
  {
    name: "Thư viện",
    icon: <IconLibrary size={18} />,
    isMenu: true,
    children: [
      {
        name: "Videos",
        path: "/videos",
        Component: VideoPage,
        icon: <IconVideo size={18} />,
        isMenu: true,
      },
      {
        name: "Chi tiết video",
        path: "/videos/:id",
        Component: VideoDetailPage,
        isMenu: false,
      },
    ],
  },
  // ================= GAMIFICATION =================
  {
    name: "Gamification",
    icon: <IconTrophy size={18} />,
    isMenu: true,
    children: [
      {
        name: "Cấp độ",
        path: "/gamification/level",
        Component: LevelPage,
        icon: <IconTrophy size={18} />,
        isMenu: true,
      },
      {
        name: "Lịch sử Điểm",
        path: "/gamification/point-transaction",
        Component: PointTransactionPage,
        icon: <IconCoins size={18} />,
        isMenu: true,
      },
    ],
  },
  {
    name: "Quản lý thông báo",
    icon: <IconBell size={18} />,
    isMenu: true,
    children: [
      {
        name: "Danh sách bài viết",
        path: "/article",
        Component: ArticlePage,
        isMenu: true,
      },
      {
        name: "Tạo bài viết mới",
        path: "/article/create",
        Component: ArticleFormPage,
        isMenu: false,
      },
      {
        name: "Cập nhật bài viết",
        path: "/article/edit/:id",
        Component: ArticleFormPage,
        isMenu: false,
      },
    ],
  },
  {
    name: "Báo lỗi/Góp ý",
    path: "/feedback",
    Component: FeedbackPage,
    icon: <IconBug size={18} />,
    isMenu: true,
  },
  {
    name: "Cấu hình Hệ thống",
    path: "/settings",
    Component: SettingsPage,
    icon: <IconSettings size={18} />,
    isMenu: true,
  },
  {
    name: "Log Hệ Thống",
    icon: <IconListDetails size={18} />,
    isMenu: true,
    children: [
      {
        name: "Log Tìm kiếm",
        path: "/log/search",
        Component: SearchLogPage,
        icon: <IconSearch size={18} />,
        isMenu: true,
      },
      {
        name: "Log Tìm kiếm Bộ từ",
        path: "/log/set-search",
        Component: SetSearchLogPage,
        icon: <IconFolderSearch size={18} />,
        isMenu: true,
      },
      {
        name: "Log Thêm Từ vựng",
        path: "/log/add-vocabulary",
        Component: AddVocabularyLogPage,
        icon: <IconPlaylistAdd size={18} />,
        isMenu: true,
      },
      {
        name: "Log Sử dụng AI",
        path: "/log/ai",
        Component: AiLogPage,
        icon: <IconSparkles size={18} />,
        isMenu: true,
      },
      {
        name: "Log Gửi Email",
        path: "/log/email",
        Component: EmailLogPage,
        icon: <IconMail size={18} />,
        isMenu: true,
      },
      {
        name: "Từ điển AI (Fallback)",
        path: "/log/ai-words",
        Component: AiWordPage,
        icon: <IconLanguage size={18} />,
        isMenu: true,
      },
      {
        name: "Log Chấm phát âm",
        path: "/log/speech-assessment",
        Component: SpeechAssessmentLogPage,
        icon: <IconMicrophone size={18} />,
        isMenu: true,
      },
      {
        name: "Log Làm bài Đọc",
        path: "/log/reading-practice",
        Component: ReadingPracticeLogPage,
        icon: <IconBook2 size={18} />,
        isMenu: true,
      },
      {
        name: "Log Web API",
        path: "/log/web-api",
        Component: () => <SystemLogPage defaultService="web-api" />,
        icon: <IconServer size={18} />,
        isMenu: true,
      },
    ],
  },
]

export default routes
